(function () {
  'use strict';

  function initMarquee(marquee) {
    var track = marquee.querySelector('.bbs-marquee__track');
    var original = marquee.querySelector('.bbs-marquee__text');
    if (!track || !original) return;

    function populate() {
      track.querySelectorAll('[aria-hidden="true"]').forEach(function (el) {
        el.parentNode.removeChild(el);
      });

      var containerWidth = marquee.offsetWidth;
      var itemWidth = original.offsetWidth;
      if (itemWidth === 0) return;

      var copies = Math.ceil((containerWidth * 2) / itemWidth) + 1;
      for (var i = 0; i < copies; i++) {
        var clone = original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      track.style.setProperty('--bbs-marquee-single-width', itemWidth + 'px');
    }

    populate();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(populate, 200);
    });
  }

  document.querySelectorAll('.bbs-marquee').forEach(initMarquee);
})();
